import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '@/api/agent';
import LibraryPage from './page';

export default function LibraryGuard() {
  const [loading, setLoading] = useState(true);
  const [isFrontUser, setIsFrontUser] = useState<boolean | null>(null);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        // 检查账号是否被禁用（state === 2）
        if (user.state === 2) {
          localStorage.removeItem('agent_token');
          setBlocked(true);
          return;
        }
        // 检查账号是否已过期（expirydate 已过当前时间）
        if (user.expirydate && user.expirydate < Date.now()) {
          localStorage.removeItem('agent_token');
          setBlocked(true);
          return;
        }
        setIsFrontUser(user.frontflag === true);
      })
      .catch(() => {
        setIsFrontUser(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
      </div>
    );
  }

  // 账号被禁用或已过期，清除 token 并跳转到登录页
  if (blocked) {
    return <Navigate to="/login" replace />;
  }

  if (!isFrontUser) {
    return <Navigate to="/admin" replace />;
  }

  return <LibraryPage />;
}
